(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('telestatApp')
        .factory('PhoneCallCheckTrackerService', PhoneCallCheckTrackerService);

    PhoneCallCheckTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'DEBUG_INFO_ENABLED'];

    function PhoneCallCheckTrackerService ($rootScope, $window, $cookies, $http, $q, DEBUG_INFO_ENABLED) {
        var stompClient = null;
        var subscriber = null;
        var subscriberU = null;
        var listener = $q.defer();
        var listenerEdit = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;
        // Main subscription flash, once activated - always active
        var subscribed = false;
        var subscribeState = false;
        var dtoStatus = {};
        var currentSessionId;

        var service = {
            connect: connect,
            disconnect: disconnect,
            sendSavePhoneCallId: sendSavePhoneCallId,
            sendEditPhoneCallId: sendEditPhoneCallId,
            sendCloseEditPhoneCallId: sendCloseEditPhoneCallId,
            subscribe: subscribe,
            //unsubscribe: unsubscribe,
            checkPhoneCallId: checkPhoneCallId,
            setListener: setListener,
            cleanListener: cleanListener,
            setEditListener: setEditListener,
            cleanEditListener: cleanEditListener
        };

        return service;

        function process(dto) {
            if (DEBUG_INFO_ENABLED) {
                console.log("Process: ");
                console.log(dto);
            }
            if (dto.action == 'disconnect') {
                for(var valueId in dtoStatus) {
                    if (dto.sessionId == dtoStatus[valueId]['sessionId']) {
                        //console.log(':: disconnect --> close');
                        dtoStatus[valueId]['action'] = 'close';
                        listener.notify(dtoStatus[valueId]);
                        delete dtoStatus[valueId];
                    }
                }
            } else if (dto.phoneCallId != null) {
                if (dto.action == 'close' && dtoStatus[dto.phoneCallId] != null && dto.sessionId == dtoStatus[dto.phoneCallId].sessionId) {
                    listener.notify(dto);
                    if (dto.sessionId != currentSessionId) {
                        listenerEdit.notify(dto);
                    }
                    delete dtoStatus[dto.phoneCallId];
                } else if (dto.action == 'edit') {
                    listener.notify(dto);
                    if (dto.sessionId != currentSessionId) {
                        listenerEdit.notify(dto);
                    }
                    if (dtoStatus[dto.phoneCallId] == null) {
                        dtoStatus[dto.phoneCallId] = dto;
                    } else {
                        if (DEBUG_INFO_ENABLED) {
                            console.log(':: parallel edit received');
                        }
                    }
                } else if (dto.action == 'save') {
                    listener.notify(dto);
                    if (dtoStatus[dto.phoneCallId] != null) {
                        if (dto.sessionId != currentSessionId) {
                            listenerEdit.notify(dto);
                        }
                        delete dtoStatus[dto.phoneCallId];
                    }
                } else {
                    if (dto.sessionId != currentSessionId) {
                        listenerEdit.notify(dto);
                    }
                }
                // Cleanup
                for(var valueId in dtoStatus) {
                    if (dto.sessionId == dtoStatus[valueId]['sessionId'] && dto.phoneCallId != dtoStatus[valueId]['phoneCallId']) {
                        dtoStatus[valueId]['action'] = 'close';
                        listener.notify(dtoStatus[valueId]);
                        if (dto.sessionId != currentSessionId) {
                            listenerEdit.notify(dto);
                        }
                        delete dtoStatus[valueId];
                    }
                }
            } else {
                console.log("Unknown DTO:");
                console.log(dto);
            }
            //console.log("On exit from process call: dtoStatus=");
            //console.log(dtoStatus);
        }

        function checkPhoneCallId(id) {
            //console.log("checkPhoneCallId: " + id);
            if (dtoStatus[id] != null && dtoStatus[id].action == 'edit') {
                //console.log("checkPhoneCallId: " + id + " result: editing");
                return dtoStatus[id];
            }
            return null;
        }

        function makeid() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            for (var i = 0; i < 8; i++)
              text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        }

        function connect () {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/phoneCall';
            currentSessionId = makeid();
            var socket = new SockJS(url, [], {
                sessionId: function() {
                    return currentSessionId
                 }
            });
            disconnect ();
            stompClient = Stomp.over(socket);
            if (!DEBUG_INFO_ENABLED) {
                stompClient.debug = null;
            }
            var headers = {};
            headers[$http.defaults.xsrfHeaderName] = $cookies.get($http.defaults.xsrfCookieName);
            stompClient.connect(headers, function() {
                connected.resolve('success');
                if (subscribed) {
                    subscribe();
                }
                listener.notify({action:'clean'});
            }, function() {
                setTimeout(function(){
                    connect();
                }, 10000);
                console.log('Can`t connect, reconnecting in 10 seconds...');
            });
        }

        function disconnect () {
            subscribeState = false;
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
            dtoStatus = {};
        }

        function setEditListener () {
            listenerEdit = $q.defer();
            return listenerEdit.promise;
        }

        function cleanEditListener () {
            listenerEdit = $q.defer();
        }

        function setListener () {
            listener = $q.defer();
            return listener.promise;
        }

        function cleanListener () {
            listener = $q.defer();
        }

        function sendSavePhoneCallId(phoneCallId) {
            sendActionPhoneCallId(phoneCallId, 'save');
        }

        function sendEditPhoneCallId(phoneCallId) {
            sendActionPhoneCallId(phoneCallId, 'edit');
        }

        function sendCloseEditPhoneCallId(phoneCallId) {
            sendActionPhoneCallId(phoneCallId, 'close');
        }

        function sendActionPhoneCallId(phoneCallId, action) {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/phoneCallCheck',
                    {},
                    angular.toJson({'phoneCallId': phoneCallId, 'action': action}));
            }
        }

        function subscribe () {
            if (!subscribeState) {
                console.log("Make new subscribe");
                connected.promise.then(function() {
                    dtoStatus = {};
                    subscribed = true;
                    subscribeState = true;
                    subscriber = stompClient.subscribe('/topic/phoneCall', function(data) {
                        process(angular.fromJson(data.body));
                    });
                    subscriberU = stompClient.subscribe('/user/topic/phoneCall', function(data) {
                        process(angular.fromJson(data.body));
                    });
                }, null, null);
            }
        }

        /*function unsubscribe () {
            subscribed = false;
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            if (subscriberU !== null) {
                subscriberU.unsubscribe();
            }
            listener = $q.defer();
            listenerEdit = $q.defer();
            dtoStatus = {};
        }*/
    }
})();
